"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ISBLANK = void 0;
exports.ISBLANK = {
    alias: 'ECEL_VAZIA',
    description: 'Retorna verdadeiro se valor for vazio',
    arg_names: ['string_para_minusculas'],
    args_description: ['valor para checar se é vazio'],
};
